import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { getCapchaCode, ReservationManager } from '../action/loginAction.js';
import { Toast,Modal,Carousel, WingBlank } from 'antd-mobile/lib';
import {getActivityById,setActivityId} from '../action/investmentAction.js';
import Util from '../util';
import { AnswerAlert,AlertResule } from './AnswerAlert'


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

  

class AnswerActivityPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertFlag:false,
      alerterrFlag:false,
      content:'',
      activityurl:'',
      ruleurl:'',
    };

  }
  componentDidMount(){

  }
  componentWillMount(){
     window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
     let {dispatch} = this.props
     console.log('id',this.props.location.query.activityId)

     let data={
      activityId:this.props.location.query.activityId
     }
     //存储ID
     dispatch(setActivityId(data))
     let callback =(data)=>{
       console.log('返回值',data)

       if (!data.content||!data.content.activityPic) {
         this.setState({
          alerterrFlag:true,
          content:data.message?data.message:'答题活动获取失败'
         })
         return
       }
       this.setState({
        activityurl:`${Util.imgUrl+data.content.activityPic}`,
        ruleurl:`${Util.imgUrl+data.content.rulePic}`,
       })
     }
    
     dispatch(getActivityById(data,callback))
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  beginAnswer(){

    hashHistory.push({
        pathname:'/Login', 
       
        state:{},
        query: {enterType:"Answer",
        activityId:this.props.location.query.activityId},
    })
  }
  pushDetail(){
  //  window.location.href = "https://www.amcfortune.com/minipage/zdz/app/index.html";
  //  window.location.href = "https://www.amcfortune.com/minipage/hxcy/app/index.html";
   window.location.href = " https://www.amcfortune.com/minipage/xywap/index.html";
  }
  alertRule(){
    this.setState({
      alertFlag:true
    })
  }
  handleClose(){
    this.setState({
      alertFlag:false
    })
  }
  render(){
    let { width, height } = window.screen;
    let { alertFlag,content,alerterrFlag,activityurl,ruleurl} = this.state;
    return(
      <div className="AnswerContent" style={{height:height}}>
    
              <div
                style={{ height:'100%', width: '100%',position:"relative",background:'#fff'}}
              >
                <img
                  src={activityurl}
                  alt=""
                  style={{ width: width,height:height, verticalAlign: 'top', }}
                />
                <div onClick={()=> {this.alertRule() }} 
                    style={{width:150,height:50,position:"absolute",top:10,right:0,zIndex:9}}
                    >
                  {/* <img
                    src={require('../img/hdgz.png')}
                    alt=""
                    style={{textAlign:'center',lineHeight:2.6,position:"absolute",top:10,right:0,zIndex:9}}
                  /> */}
                </div>
                
                <div className="jionAnswer" style={{width:width,bottom:width/(750/180),height:width/(750/75),zIndex:9,textAlign:'center' }}>
                  <div onClick={()=> {this.beginAnswer()}} style={{width:width,textAlign:'center'}} >
                  {/* <img
                    src={require('../img/dtan.png')}
                    alt=""
                    style={{width:width/(750/600)}}
                  /> */}
                  </div>
                </div>
                {/* <div className="jionMore" style={{width:width,bottom:width/(750/76),height:width/(750/75),zIndex:9, }}>
                  <div onClick={()=> {this.pushDetail() }} style={{height:width/(750/75),}}></div>
                </div> */}
              </div>
        {
          alertFlag ? <AnswerAlert url={ruleurl} Close={ this.handleClose.bind(this) } /> : null
        }
        {
          alerterrFlag?<AlertResule content={content} /> : null
        }
        
      </div>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(AnswerActivityPage);



// WEBPACK FOOTER //
// ./src/components/AnswerActivityPage.js